import { Link } from "react-router-dom";
import { ArrowRight, Award, Camera, Sparkles } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import CtaBand from "@/components/site/CtaBand";
import RealisationsCarousel from "@/components/site/RealisationsCarousel";
import SEO from "@/components/site/SEO";

export default function Realisations() {
  return (
    <div data-testid="realisations-page">
      <SEO
        title="Réalisations plomberie & chauffage | RM Plomberie Beblenheim"
        description="Découvrez prochainement nos chantiers en plomberie, chauffage et VMC à Colmar, Mulhouse, Strasbourg et tout le Haut-Rhin. Travail soigné et finitions de qualité."
        keywords="réalisations plombier Colmar, chantier chauffage Mulhouse, rénovation salle de bain Haut-Rhin, installations RM Plomberie"
      />
      <PageHero
        breadcrumb="Réalisations"
        title="ations"
        highlight="Réalis"
        subtitle="Découvrez prochainement une sélection de nos chantiers en plomberie, chauffage et ventilation. Des réalisations de qualité, soignées et professionnelles."
        useLogo
      />

      <RealisationsCarousel />

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-[#005BBB]/10 mb-6">
            <Camera className="w-10 h-10 text-[#005BBB]" />
          </div>

          <p className="text-xs uppercase tracking-[0.28em] font-semibold text-[#005BBB] mb-3">Galerie en préparation</p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#001B35]">
            D'autres chantiers arrivent <span className="text-[#005BBB]">bientôt</span>
          </h2>
          <div className="mt-5 w-16 h-1 bg-[#005BBB] mx-auto rounded-full" />

          <p className="mt-7 text-gray-700 leading-relaxed max-w-2xl mx-auto">
            Rénovations de salle de bain, installations de chaudières, plancher chauffant, pompes à chaleur, VMC double flux… De nouveaux chantiers sont ajoutés régulièrement. Revenez d'ici quelques semaines pour découvrir nos dernières réalisations en images.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
            {[
              { Icon: Award, label: "Travail soigné" },
              { Icon: Sparkles, label: "Chaque projet unique" },
              { Icon: Camera, label: "Photos à venir" },
            ].map(({ Icon, label }) => (
              <div key={label} className="bg-[#F5F7FA] rounded-2xl p-5 flex flex-col items-center gap-2">
                <Icon className="w-6 h-6 text-[#005BBB]" />
                <span className="text-sm font-semibold text-[#001B35]">{label}</span>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-[#F5F7FA] rounded-2xl p-8 flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="text-left">
              <p className="font-display text-lg font-bold text-[#001B35]">Vous avez un projet en tête ?</p>
              <p className="text-sm text-gray-600 mt-1">Demandez un devis gratuit, nous vous répondons rapidement.</p>
            </div>
            <Link to="/contact" data-testid="realisations-cta" className="inline-flex items-center gap-2 bg-[#005BBB] hover:bg-[#001B35] text-white rounded-full px-6 py-3 font-semibold uppercase text-sm tracking-wider transition btn-shine flex-shrink-0">
              Demander un devis <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
